function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Reference from '../Reference';
var ReferenceSet = /*#__PURE__*/ function() {
    "use strict";
    function ReferenceSet() {
        _class_call_check(this, ReferenceSet);
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    _create_class(ReferenceSet, [
        {
            key: "size",
            get: function get() {
                return this.list.size + this.refs.size;
            }
        },
        {
            key: "describe",
            value: function describe() {
                var description = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        description.push(item);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.refs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = _sliced_to_array(_step1.value, 2), ref = _step_value[1];
                        description.push(ref.describe());
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return description;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return Array.from(this.list).concat(Array.from(this.refs.values()));
            }
        },
        {
            key: "resolveAll",
            value: function resolveAll(resolve) {
                return this.toArray().reduce(function(acc, e) {
                    return acc.concat(Reference.isRef(e) ? resolve(e) : e);
                }, []);
            }
        },
        {
            key: "add",
            value: function add(value) {
                Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
            }
        },
        {
            key: "clone",
            value: function clone() {
                var next = new ReferenceSet();
                next.list = new Set(this.list);
                next.refs = new Map(this.refs);
                return next;
            }
        },
        {
            key: "merge",
            value: function merge(newItems, removeItems) {
                var next = this.clone();
                newItems.list.forEach(function(value) {
                    return next.add(value);
                });
                newItems.refs.forEach(function(value) {
                    return next.add(value);
                });
                removeItems.list.forEach(function(value) {
                    return next.delete(value);
                });
                removeItems.refs.forEach(function(value) {
                    return next.delete(value);
                });
                return next;
            }
        }
    ]);
    return ReferenceSet;
}();
export { ReferenceSet as default };
